export default "__VITE_ASSET__B7X1W0Mn__"